import { render } from "./ArchiveMonos.vue?vue&type=template&id=7cca2dcd&scoped=true"
import script from "./ArchiveMonos.vue?vue&type=script&lang=js"
export * from "./ArchiveMonos.vue?vue&type=script&lang=js"

import "./ArchiveMonos.vue?vue&type=style&index=0&id=7cca2dcd&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cca2dcd"]])

export default __exports__